import { initialState } from '@/store/Utm/initialState';

const state = initialState;

const getters = {
  referral: (state) => state.referral,
};

export default {
  state,
  getters,
};
